module.exports = __webpack_public_path__ + "static/media/logotypywszystkie.ecf48fac.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/logotypywszystkie.png
// module id = 629
// module chunks = 0